import React from "react";
import Dispatcher from "../../dispatcher";
import BookStore from "../../stores/book-store";
import HighlightStore from "../../stores/highlight-store";
import MarkerStore from "../../stores/marker-store";

var BooleanToggle = require("./boolean-toggle").BooleanToggle;
var Tree = require("./tree");
var TreeItem = require("./tree-item");
import EditContainer from "../layouts/edit-container";
var Isvg = require("../../../vendor/react-inlinesvg");
var Menu = require("./menu").Menu;
var MenuMixin = require("./menu").MenuMixin;
var MenuList = require("./menu-list");

class NotebookDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      highlights: false,
      toc: false,
      showOptions: false,
      notesOnly: false,
      randomOrder: false,
      order: "book",
      title: this.props.title,
      printDisabled: false,
      printLimit: 500,
      showMineHighlighters: true,
      showTheirsHighlighters: true
    };

    // MenuMixin bindings
    this._toggleMenu = MenuMixin._toggleMenu.bind(this);
    this._showMenu = MenuMixin._showMenu.bind(this);
    this._removeMenu = MenuMixin._removeMenu.bind(this);
    this._redrawMenu = MenuMixin._redrawMenu.bind(this);

    // Method bindings
    this._updateData = this._updateData.bind(this);
    this._getTOC = this._getTOC.bind(this);
    this._getSelectedHighlights = this._getSelectedHighlights.bind(this);
    this._compareBookOrder = this._compareBookOrder.bind(this);
    this._selectAllChildren = this._selectAllChildren.bind(this);
    this._selectAll = this._selectAll.bind(this);
    this._deselectAllChildren = this._deselectAllChildren.bind(this);
    this._deselectAll = this._deselectAll.bind(this);
    this._isHighlightSelected = this._isHighlightSelected.bind(this);
    this._getHighlightCountOfSection = this._getHighlightCountOfSection.bind(this);
    this._updateHighlightCounts = this._updateHighlightCounts.bind(this);
    this._onHighlighterCheckboxChange = this._onHighlighterCheckboxChange.bind(this);
    this._onChapterCheckboxChange = this._onChapterCheckboxChange.bind(this);
    this._onSubscribedCheckboxChange = this._onSubscribedCheckboxChange.bind(this);
    this._childSelectionStatus = this._childSelectionStatus.bind(this);
    this._onCheckboxChange = this._onCheckboxChange.bind(this);
    this._populateTOCWithHighlights = this._populateTOCWithHighlights.bind(this);
    this._getTopLevelCounts = this._getTopLevelCounts.bind(this);
    this._someAreSelected = this._someAreSelected.bind(this);
    this._getSections = this._getSections.bind(this);
    this._bookUsesMarker = this._bookUsesMarker.bind(this);
    this._getHighlighters = this._getHighlighters.bind(this);
    this._changeOrder = this._changeOrder.bind(this);
    this._resetSections = this._resetSections.bind(this);
    this._saveSections = this._saveSections.bind(this);
    this._allChecked = this._allChecked.bind(this);
    this._allUnChecked = this._allUnChecked.bind(this);
    this._cancelOptions = this._cancelOptions.bind(this);
    this._options = this._options.bind(this);
    this._randomOrder = this._randomOrder.bind(this);
    this._notesOnly = this._notesOnly.bind(this);
    this._updateDescription = this._updateDescription.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
    this._previewPrintNotes = this._previewPrintNotes.bind(this);
    this._optionsPrintNotes = this._optionsPrintNotes.bind(this);
    this.renderEditContainer = this.renderEditContainer.bind(this);
    this.renderEmptyPage = this.renderEmptyPage.bind(this);
    this.renderMassSelection = this.renderMassSelection.bind(this);
    this.renderOptionsMenu = this.renderOptionsMenu.bind(this);
    this.renderSelectedCount = this.renderSelectedCount.bind(this);
    this.renderOptionsBar = this.renderOptionsBar.bind(this);
    this._toggleSectionMenu = this._toggleSectionMenu.bind(this);
    this.renderOneNoteButtons = this.renderOneNoteButtons.bind(this);
    this.renderTree = this.renderTree.bind(this);
    this.renderReviewFooter = this.renderReviewFooter.bind(this);
    this.renderReviewSetup = this.renderReviewSetup.bind(this);

    // From componentWillMount
    this.highlighterNames = {};
  }

  componentDidMount() {
    this._updateData();
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 2);
    Dispatcher.bind(Dispatcher.BOOK_TOC_LOADED, this._updateData);
    Dispatcher.bind(Dispatcher.HIGHLIGHTS_CHANGE, this._updateData);
    this.onSubmit = this.props.onSubmit;
  }

  componentWillUnmount() {
    Dispatcher.removeListener(Dispatcher.BOOK_TOC_LOADED, this._updateData);
    Dispatcher.removeListener(Dispatcher.HIGHLIGHTS_CHANGE, this._updateData);
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 2);
  }

  componentDidUpdate() {
    if (!this.props.toc || !this.props.highlights) {
      Fraction.Helpers.removeLoader(".loading-notebook-dialog-setup");
      Fraction.Helpers.addLoader(".loading-notebook-dialog-setup");
    }
  }

  _updateData() {
    Fraction.Helpers.removeLoader(".loading-notebook-dialog-setup");
    const book = BookStore.get(this.props.isbn);
    const highlights = HighlightStore.combinedHighlights(this.props.isbn);
    this._updateDescription(highlights.length);
    this.setState({
      highlights: highlights.sort(this._compareBookOrder),
      toc: book.getTOC()
    });
  }

  _getTOC() {
    if (!this.toc) {
      this.toc = this.state.toc.reduce((toc, node) => {
        return toc.concat({
          title: node.title,
          cfi: node.cfi,
          level: node.level,
          highlights: []
        });
      }, []);
    }
    return this.toc;
  }

  _getSelectedHighlights(sections) {
    var selectedHighlights = { mine: [], theirs: [] };
    if (sections === undefined) {
      sections = this.sections;
    }
    if (!sections) {
      return selectedHighlights;
    } else {
      var i, j;
      for (i = 0; i < sections.length; i++) {
        var section = sections[i];
        if (section.checkedStatus > 0 && section.count > 0) {
          for (j = 0; j < section.highlights.length; j++) {
            var highlight = section.highlights[j];
            if (this._isHighlightSelected(highlight)) {
              if (highlight.shared) {
                selectedHighlights.theirs.push(highlight);
              } else {
                selectedHighlights.mine.push(highlight);
              }
            }
          }
        }
        var childHighlights = this._getSelectedHighlights(section.children);
        selectedHighlights.theirs = selectedHighlights.theirs.concat(
          childHighlights.theirs
        );
        selectedHighlights.mine = selectedHighlights.mine.concat(
          childHighlights.mine
        );
      }
    }
    return selectedHighlights;
  }

  _compareBookOrder(a, b) {
    // sort by cfi (epub)
    if (a.cfi) {
      return Jigsaw.CFIUtils.compareCFIs(a.cfi, b.cfi);
    }
    const chapterOffsetDiff = a.chapterOffset - b.chapterOffset;
    const startPageDiff = a.startPage - b.startPage;
    // sort by startPage, then by chapterOffset (picture books: pdf/pbk)
    if (a.startPage) {
      return startPageDiff || chapterOffsetDiff;
    }
    // sort by chapterCfi, then by chapterOffset (dash)
    return (
      Jigsaw.CFIUtils.compareCFIs(a.chapterCfi, b.chapterCfi) ||
      chapterOffsetDiff
    );
  }

  _selectAllChildren(section) {
    if (section.children) {
      section.children.forEach(child => {
        child.checkedStatus = 2;
        child.isChecked = true;
        this._selectAllChildren(child);
      });
    }
  }

  _selectAll() {
    const sections = this.state.showOptions ? this.highlighters : this.sections;
    sections.forEach(section => {
      section.isChecked = true;
      section.checkedStatus = 2;
      this._selectAllChildren(section);
    });
    this._updateDescription();
    this.forceUpdate();
  }

  _deselectAllChildren(section) {
    if (section.children) {
      section.children.forEach(child => {
        child.checkedStatus = 0;
        child.isChecked = false;
        this._deselectAllChildren(child);
      });
    }
  }

  _deselectAll() {
    const sections = this.state.showOptions ? this.highlighters : this.sections;
    sections.forEach(section => {
      section.isChecked = false;
      section.checkedStatus = 0;
      this._deselectAllChildren(section);
    });
    this._updateDescription();
    this.forceUpdate();
  }

  _isHighlightSelected(highlight, ignoreCheck) {
    return (
      ((ignoreCheck || this.highlighterNames[highlight.markerId].isChecked) &&
        !this.state.notesOnly) ||
      (highlight.hasNote && highlight.noteText.length > 0)
    );
  }

  _getHighlightCountOfSection(section) {
    var total = 0;
    var i, highlight;
    for (i = 0; i < section.children.length; i++) {
      total = total + this._getHighlightCountOfSection(section.children[i]);
    }
    if (section.tocNode) {
      for (i = 0; i < section.tocNode.highlights.length; i++) {
        highlight = section.tocNode.highlights[i];
        if (this._isHighlightSelected(highlight)) {
          total++;
        }
      }
    } else if (section.globalId) {
      for (i = 0; i < this.state.highlights.length; i++) {
        highlight = this.state.highlights[i];
        if (
          highlight.markerId === section.globalId &&
          this._isHighlightSelected(highlight, true)
        ) {
          total++;
        }
      }
    }
    return total;
  }

  _updateHighlightCounts(sections) {
    for (var i = 0; i < sections.length; i++) {
      sections[i].count = this._getHighlightCountOfSection(sections[i]);
      for (var j = 0; j < sections[i].children.length; j++) {
        sections[i].children = this._updateHighlightCounts(
          sections[i].children
        );
      }
    }
    return sections;
  }

  _onHighlighterCheckboxChange(event, node) {
    this._onCheckboxChange(this.highlighters, event, node);
    this.setState({
      showMineHighlighters: this.highlighters[0].checkedStatus >= 1,
      showTheirsHighlighters: this.highlighters[1].checkedStatus >= 1
    });
    this._updateDescription();
  }

  _onChapterCheckboxChange(event, node) {
    this._onCheckboxChange(this.sections, event, node);
    this._updateDescription();
  }

  _onSubscribedCheckboxChange(event, node) {
    this._onCheckboxChange(this.subscriptions, event, node);
  }

  _childSelectionStatus(section) {
    if (section.children && section.children.length) {
      if (
        section.children
          .map(child => this._childSelectionStatus(child))
          .every(status => status === 2)
      ) {
        return 2;
      }

      if (
        section.children
          .map(child => this._childSelectionStatus(child))
          .some(status => status === 1 || status === 2)
      ) {
        return 1;
      }

      return section.children.some(
        child => this._childSelectionStatus(child) === 0
      )
        ? 0
        : 2;
    }
    return section.checkedStatus;
  }

  _onCheckboxChange(sections, e, node) {
    var dataLoc =
      $(e.currentTarget)
        .parent()
        .parent()
        .parent()
        .data("locator") + "";
    var parts = dataLoc.split(".");
    var queue = [];
    var checkedSection;
    while (parts.length > 0) {
      checkedSection = sections[parseInt(parts.shift(), 10)];
      queue.push(checkedSection);
      sections = checkedSection.children;
    }
    if (checkedSection.isChecked) {
      checkedSection.isChecked = false;
      checkedSection.checkedStatus = 0;
      this._deselectAllChildren(checkedSection);
    } else {
      checkedSection.isChecked = true;
      checkedSection.checkedStatus = 2;
      this._selectAllChildren(checkedSection);
    }
    while (queue.length > 0) {
      var section = queue.pop();
      section.checkedStatus = this._childSelectionStatus(section);
      section.isChecked = section.checkedStatus === 2;
    }
    this.forceUpdate();
  }

  _populateTOCWithHighlights(toc) {
    const book = BookStore.get(this.props.isbn);
    if (!this.populatedTOC) {
      for (var i = 0; i < this.state.highlights.length; i++) {
        var highlight = this.state.highlights[i];
        for (var j = toc.length - 1; j >= 0; j--) {
          if (book.format === "pbk") {
            if (toc[j].title === highlight.chapterTitle) {
              toc[j].highlights.push(highlight);
              break;
            }
          } else {
            if (toc[j].level <= 3) {
              var compare = Jigsaw.CFIUtils.compareCFIs(
                highlight.cfi || highlight.chapterCfi,
                toc[j].cfi
              );
              if (compare >= 0 || j === 0) {
                toc[j].highlights.push(highlight);
                break;
              }
            }
          }
        }
      }
      this.populatedTOC = true;
    }
    return toc;
  }

  _getTopLevelCounts(sections) {
    return sections.reduce((counter, section) => counter + section.count, 0);
  }

  _someAreSelected(sections) {
    return sections.some(
      section => section.count > 0 && section.checkedStatus >= 1
    );
  }

  _getSections() {
    var toc = this._populateTOCWithHighlights(this._getTOC());
    var highlighters = this._getHighlighters();
    if (!this.sections) {
      this.sectionHighlights = {};
      // get that toc in order
      this.sections = [];
      var lastLevel = 1;
      var sectionQueue = [];
      for (var i = 0; i < toc.length; i++) {
        if (toc[i].level <= 3) {
          var section = {
            title: toc[i].title,
            children: [],
            count: 0,
            isChecked: true,
            checkedStatus: 2,
            hideIfEmpty: true,
            tocNode: toc[i],
            onCheck: this._onChapterCheckboxChange,
            highlights: toc[i].highlights
          };
          for (var q = 0; q < section.highlights.length; q++) {
            this.sectionHighlights[section.highlights[q].syncId] = section;
          }
          if (toc[i].level === 1) {
            this.sections.push(section);
          } else {
            if (toc[i].level <= lastLevel) {
              var diff = lastLevel - toc[i].level + 1;
              for (diff; diff > 0; diff--) {
                sectionQueue.pop();
              }
            }
            sectionQueue[sectionQueue.length - 1].children.push(section);
          }
          lastLevel = toc[i].level;
          sectionQueue.push(section);
        }
      }
    }
    this.sections = this._updateHighlightCounts(this.sections);
  }

  _bookUsesMarker(marker) {
    const combinedHighlights = HighlightStore.combinedHighlights(
      this.props.isbn
    );
    return combinedHighlights.some(
      highlight => highlight.markerId === marker.globalId
    );
  }

  _getHighlighters() {
    var i;
    if (!this.highlighters) {
      this.highlighterNames = {};
      var combinedMarkers = MarkerStore._getCombinedMarkers();
      for (i = 0; i < combinedMarkers.length; i++) {
        var marker = combinedMarkers[i];
        if (!this._bookUsesMarker(marker)) {
          continue;
        }
        var section = {
          title: (
            <span>
              <span
                className="highlighter-tree-item-dot"
                style={{
                  background: marker.vstColor,
                  borderColor: marker.vstColorDark
                }}
              />
              {marker.label}
            </span>
          ),
          titleString: marker.label,
          isChecked: true,
          checkedStatus: 2,
          children: [],
          count: 1,
          hideNumbers: true,
          hideIfEmpty: true,
          onCheck: this._onHighlighterCheckboxChange
        };
        this.highlighterNames[marker.globalId] = $.extend(
          true,
          marker,
          section
        );
      }

      this.highlighters = [];
      var keys = Object.keys(this.highlighterNames);
      var shared = [];
      var mine = [];
      var people = {};
      var peopleList = [];
      for (i = 0; i < keys.length; i++) {
        var marker = this.highlighterNames[keys[i]];
        if (marker.subscribed) {
          //shared.push(marker);
          if (!people[marker.userGuid]) {
            var peopleObject = {
              title: marker.authorName,
              children: [],
              isChecked: true,
              count: 0,
              hideNumbers: true,
              hideIfEmpty: true,
              checkedStatus: 2,
              onCheck: this._onHighlighterCheckboxChange
            };
            peopleList.push(peopleObject);
            people[marker.userGuid] = peopleObject;
          }
          people[marker.userGuid].children.push(marker);
        } else {
          mine.push(marker);
        }
      }
      this.highlighters.push({
        title: i18n.t("review-mode.my-highlighters"),
        expanded: true,
        children: mine,
        isChecked: true,
        count: 0,
        hideNumbers: true,
        hideIfEmpty: true,
        checkedStatus: 2,
        onCheck: this._onHighlighterCheckboxChange
      });
      this.highlighters.push({
        title: i18n.t("review-mode.followed-highlighters"),
        expanded: true,
        children: peopleList,
        isChecked: true,
        count: 0,
        hideNumbers: true,
        hideIfEmpty: true,
        checkedStatus: 2,
        onCheck: this._onHighlighterCheckboxChange
      });
    }

    this.highlights = this._updateHighlightCounts(this.highlighters);
  }

  _changeOrder(e) {
    this.setState({ order: $(e.currentTarget).data("key") });
    this.forceUpdate();
  }

  _resetSections(sections) {
    sections.forEach(section => {
      section.isChecked = section.lastChecked;
      section.checkedStatus = section.lastCheckedStatus;
      this._resetSections(section.children);
    });
  }

  _saveSections(sections) {
    sections.forEach(section => {
      section.lastChecked = section.isChecked;
      section.lastCheckedStatus = section.checkedStatus;
      this._saveSections(section.children);
    });
  }

  _allChecked() {
    const sections = this.state.showOptions ? this.highlighters : this.sections;
    return sections.every(section => section.isChecked);
  }

  _allUnChecked() {
    const sections = this.state.showOptions ? this.highlighters : this.sections;
    return false; //sections.every(section => !section.isChecked)
  }

  _cancelOptions() {
    this._resetSections(this.highlighters);
    if (this.state.randomOrder !== this.state.lastRandomOrder) {
      $("#random-order .boolean-toggle").click();
    }
    if (this.state.notesOnly !== this.state.lastNotesOnly) {
      $("#notes-only .boolean-toggle").click();
    }
    this._options();
  }

  _options() {
    $("#review-options-menu").slideToggle(
      250,
      function() {
        $(".notebook-setup-sections").toggle();
        this.props.toggleCloseButton(!this.state.showOptions);
        this._saveSections(this.highlighters);
        var newTitle = "";
        var newDescription = i18n.t("review-mode.review-description");
        if (this.state.showOptions) {
          // do the opposite here, set title to customize review
          $("#show-review-options").focus();
          newTitle = i18n.t("review-mode.customize-your-review");
        } else {
          // change title to options
          $(".modal-title").focus();
          if (Fraction.Helpers.isSmallScreen()) {
            newTitle = i18n.t("review-mode.review-options-mobile");
          } else {
            newTitle = i18n.t("review-mode.review-options");
          }
          newDescription = false;
        }
        this.props.changeModalTitle(newTitle);
        this.props.changeModalDescription(newDescription);
        this.setState({
          title: newTitle,
          showOptions: !this.state.showOptions,
          lastRandomOrder: this.state.randomOrder,
          lastNotesOnly: this.state.notesOnly
        });
      }.bind(this)
    );
  }

  _randomOrder() {
    this.setState({ randomOrder: !this.state.randomOrder });
  }

  _notesOnly() {
    this.setState({ notesOnly: !this.state.notesOnly });
  }

  _updateDescription(totalSelected = null) {
    if (!this.props.isReviewMode) {
      const selectedHighlights = this._getSelectedHighlights();
      totalSelected =
        totalSelected ||
        selectedHighlights.mine.length + selectedHighlights.theirs.length;
      if (totalSelected > this.state.printLimit) {
        if (Fraction.Helpers.isSmallScreen()) {
          return Fraction.Helpers.toast(i18n.t("print-notes.disclaimer"), {
            type: "error"
          });
        }
        this.props.changeModalDescription(
          <span style={{ color: "red" }}>
            {i18n.t("print-notes.disclaimer")}
          </span>
        );
      } else {
        this.props.changeModalDescription("");
      }
    }
  }

  _onSubmit() {
    const highlighters = this._getSelectedHighlights();
    this.onSubmit(highlighters);
  }

  _previewPrintNotes() {
    const highlighters = this._getSelectedHighlights();
    this.props.previewPrintNotes(highlighters);
  }

  _optionsPrintNotes() {
    const highlighters = this._getSelectedHighlights();
    this.props.optionsPrintNotes(highlighters);
  }

  renderEditContainer(child) {
    const leftHeader = (
      <span>
        <Isvg src="/img/mobile_arrow.svg" />
        <span className="offScreen">{i18n.t("base.cancel")}</span>
      </span>
    );
    if (Fraction.Helpers.isSmallScreen()) {
      if (this.props.isReviewMode) {
        return (
          <EditContainer
            leftHeader={leftHeader}
            title={this.state.title}
            saveEditCallback={false}
            className={this.state.showOptions ? "hide-header" : ""}
            cancelEditCallback={Fraction.Helpers.removeModal}
          >
            {child}
          </EditContainer>
        );
      } else {
        return (
          <EditContainer
            leftHeader={leftHeader}
            title={this.props.title}
            saveEditCallback={false}
            cancelEditCallback={Fraction.Helpers.removeModal}
          >
            {child}
          </EditContainer>
        );
      }
    }
    return child;
  }

  renderEmptyPage() {
    return (
      <div className="notebook-dialog-sections null">
        <div className="null-notebook-dialog">
          {i18n.t("review-mode.no-highlights-in-book")}
        </div>
      </div>
    );
  }

  renderMassSelection() {
    if (!this.state.showOptions) {
      return (
        <span className="select-options">
          <button
            className={"noButton " + (this._allUnChecked() && "disabled")}
            onClick={this._deselectAll}
          >
            {i18n.t("base.deselect-all")}
          </button>
          <button
            className={"noButton " + (this._allChecked() && "disabled")}
            onClick={this._selectAll}
          >
            {i18n.t("base.select-all")}
          </button>
        </span>
      );
    }
  }

  renderOptionsMenu() {
    return (
      <div id="review-options-menu" aria-hidden={!this.state.showOptions}>
        <div className="mobile-review-options-header header">
          <div className="edit-title">{this.state.title}</div>
          {this._someAreSelected(this.highlighters) && (
            <button
              className="edit-button save-edit noButton"
              onClick={this._options}
              disabled={!this._someAreSelected(this.highlighters)}
            >
              {i18n.t("base.apply")}
            </button>
          )}
        </div>
        <div className="review-mode-markers">
          <div id="notes-only" className="notebook-options-bar">
            <div id="reviewHighlights">
              {i18n.t("review-mode.highlights-with-notes")}
            </div>
            <BooleanToggle
              describedBy="reviewHighlights"
              initialState={this.state.notesOnly}
              toggleOn={this._notesOnly}
              toggleOff={this._notesOnly}
              onText={i18n.t("base.on").capitalize()}
              offText={i18n.t("base.off").capitalize()}
            />
          </div>
          <div id="random-order" className="notebook-options-bar">
            <div id="randomOrder">{i18n.t("review-mode.random-order")}</div>
            <BooleanToggle
              describedBy="randomOrder"
              initialState={this.state.randomOrder}
              toggleOn={this._randomOrder}
              toggleOff={this._randomOrder}
              onText={i18n.t("base.on").capitalize()}
              offText={i18n.t("base.off").capitalize()}
            />
          </div>
          <div className="notebook-options-bar">
            {i18n.t("highlighters.highlighters")}
            {this.renderMassSelection()}
          </div>
          <div id="highlighter-tree">
            {this.renderTree(
              this.highlighters,
              i18n.t("review-mode.no-highlighters")
            )}
          </div>
        </div>
        <div className="notebook-setup-actions">
          <button
            onClick={this._cancelOptions}
            className="noButton cancel-button"
          >
            {i18n.t("base.cancel")}
          </button>
          <button
            onClick={this._options}
            className="submit"
            disabled={!this._someAreSelected(this.highlighters)}
          >
            {i18n.t("base.apply")}
          </button>
        </div>
      </div>
    );
  }

  renderSelectedCount() {
    const selectedHighlights = this._getSelectedHighlights();
    let isSmallScreen = Fraction.Helpers.isSmallScreen();
    let totalSelected =
      selectedHighlights.mine.length + selectedHighlights.theirs.length;
    if (!this.state.showOptions) {
      if (this.props.isReviewMode) {
        return (
          <span className="selected-options">
            {!isSmallScreen && (
              <span className="selected-label">
                {i18n.t("review-mode.selected")}
              </span>
            )}
            <span aria-describedby={i18n.t("review-mode.my-notes-highlights")}>
              <Isvg src="/img/mine_review.svg" />
              <span id={i18n.t("review-mode.my-notes-highlights")}>
                (
                {this.state.showMineHighlighters
                  ? selectedHighlights.mine.length
                  : 0}
                )
              </span>
              <span className="offScreen">
                {i18n.t("review-mode.my-notes-or-highlights")}
              </span>
            </span>
            <span
              aria-describedby={i18n.t(
                "review-mode.subscriber-notes-highlights"
              )}
            >
              <Isvg src="/img/following_review.svg" />
              <span id={i18n.t("review-mode.subscriber-notes-highlights")}>
                (
                {this.state.showTheirsHighlighters
                  ? selectedHighlights.theirs.length
                  : 0}
                )
              </span>
              <span className="offScreen">
                {i18n.t("review-mode.subscriber-notes-or-highlights")}
              </span>
              {this.state.notesOnly && !isSmallScreen
                ? ", " + i18n.t("review-mode.notes-only")
                : ""}
            </span>
            <span>
              {this.state.randomOrder && !isSmallScreen
                ? ", " + i18n.t("review-mode.random")
                : ""}
            </span>
          </span>
        );
      }
      return (
        <span className="selected-options">
          {!isSmallScreen && <span>{i18n.t("review-mode.selected")}</span>}
          <span aria-describedby={i18n.t("review-mode.my-notes-highlights")}>
            ({totalSelected})
          </span>
        </span>
      );
    }
  }

  renderOptionsBar() {
    if (this.props.isReviewMode) {
      return (
        <div className="notebook-options-bar">
          {this.renderOptionsMenu()}
          {this.renderSelectedCount()}
          {this.renderMassSelection()}
        </div>
      );
    }
    return (
      <div
        className={
          "notebook-options-bar noselect " +
          (this.props.isOneNote && "one-note-options-bar") +
          (this.props.showPreviewOptions ? " toggle-off" : "")
        }
      >
        {this.renderSelectedCount()}
        {this.renderMassSelection()}
      </div>
    );
  }

  _toggleSectionMenu(e) {
    this._toggleMenu(
      e,
      {
        menuId: "default-loc-dropdown"
      },
      this.props.toggleDropDown(true)
    );
  }

  renderOneNoteButtons() {
    return (
      <div
        className={
          "actions " + (this.props.showPreviewOptions ? "preview-mode" : "")
        }
      >
        <button
          className={
            "noButton one-note-button large " +
            (this.props.showPreviewOptions ? "toggle-off" : "")
          }
          onClick={this._previewPrintNotes}
        >
          {i18n.t("one-note.preview")}
        </button>
        <button
          data-menu-id="default-loc-dropdown"
          aria-expanded="false"
          className={
            "noButton default-location-button " +
            (this.props.showPreviewOptions ? "" : "toggle-off")
          }
          onClick={this._toggleSectionMenu}
        >
          {this.props.menuTitle}
        </button>
        <Menu
          key="default-loc-menu"
          menuId="default-loc-dropdown"
          direction="down"
        >
          {this.props.menuItems && (
            <MenuList
              key="default-loc-menu-list"
              items={this.props.menuItems}
            />
          )}
          {this.props.menuHTML}
        </Menu>
        <button
          className={
            "noButton one-note-button small " +
            (this.props.showPreviewOptions ? "" : "toggle-off")
          }
          onClick={this._onSubmit}
        >
          {i18n.t("one-note.send")}
        </button>
      </div>
    );
  }

  renderTree(items, placeholder, checkbox = true) {
    if (this._getTopLevelCounts(items) > 0) {
      return <Tree data={items} checkbox={checkbox} />;
    }
    return <div className="null-notebook-dialog">{placeholder}</div>;
  }

  renderReviewFooter() {
    if (this.props.isReviewMode) {
      return (
        <div className="notebook-setup-actions start-review">
          <button
            id="show-review-options"
            className="submit noButton"
            onClick={this._options}
          >
            <Isvg src="/img/settings.svg">NS</Isvg>
            {Fraction.Helpers.isSmallScreen() ? (
              <span>{i18n.t("review-mode.review-options-mobile")}</span>
            ) : (
              <span>{i18n.t("review-mode.review-options")}</span>
            )}
          </button>
          <button
            onClick={Fraction.Helpers.removeModal}
            className="cancel-button noButton"
          >
            {i18n.t("base.cancel")}
          </button>
          <button
            onClick={this._onSubmit}
            className="submit start-review-button"
            disabled={!this._someAreSelected(this.sections)}
          >
            {i18n.t("review-mode.start-review")}
          </button>
        </div>
      );
    } else if (this.props.isOneNote) {
      return (
        <div className="notebook-setup-actions noselect one-note-footer">
          <button
            className={
              "noButton options-button " +
              (this.props.showPreviewOptions ? "" : "toggle-off")
            }
            onClick={this._optionsPrintNotes}
          >
            {i18n.t("base.options")}
          </button>
          <span>
            {i18n.t("one-note.signed-into-onenote-as", {
              user: this.props.createdByName
            })}
          </span>
          <button onClick={this.props.signOutOneNote} className="noButton">
            {i18n.t("global-bar.sign-out")}
          </button>
        </div>
      );
    }
    const selectedHighlights = this._getSelectedHighlights();
    let totalSelected =
      selectedHighlights.mine.length + selectedHighlights.theirs.length;
    return (
      <div className="notebook-setup-actions noselect">
        <button
          onClick={Fraction.Helpers.VSTModals.removeVSTModal}
          className="cancel-print-button noButton"
        >
          {i18n.t("base.cancel")}
        </button>
        <button
          onClick={this._onSubmit}
          className="submit print-notes-button"
          disabled={
            !this._someAreSelected(this.sections) ||
            totalSelected > this.state.printLimit
          }
        >
          {i18n.t("print.print")}
        </button>
      </div>
    );
  }

  renderReviewSetup() {
    this._getSections();
    var previewTop = {};
    if (this.props.showPreviewOptions) {
      previewTop = { top: "10px" };
      var exportDate = new Date()
        .toString()
        .split(" ")
        .splice(1, 3)
        .join(" ");
      document.getElementById("date").innerHTML = exportDate;
    }
    return (
      <div className="notebook-dialog-sections">
        <div id="select-sections" className="setup-select">
          {this.renderOptionsBar()}
          <div
            style={previewTop}
            id="notesPreview"
            className={
              "notebook-setup-sections " +
              (this.props.isOneNote && "one-note-content")
            }
          >
            {this.props.isOneNote && (
              <div
                style={{ fontWeight: 700, color: "#949494" }}
                id="returnDate"
              >
                {i18n.t("one-note.date-exported")} <span id="date" />
              </div>
            )}
            {this.props.showPreviewOptions
              ? this.props.renderPreviewNotes
              : this.renderTree(
                  this.sections,
                  i18n.t("review-mode.nothing-to-review")
                )}
          </div>
          {this.props.isOneNote && this.renderOneNoteButtons()}
          {this.renderReviewFooter()}
        </div>
      </div>
    );
  }

  render() {
    if (this.state.highlights && this.state.toc) {
      if (this.state.highlights.length === 0) {
        return this.renderEditContainer(this.renderEmptyPage());
      }
      return this.renderEditContainer(this.renderReviewSetup());
    }
    return <div className="loading-notebook-dialog-setup" />;
  }
}

module.exports = NotebookDialog;
